/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { Link } from 'react-router-dom';
import { useLeadUrl } from '../route/route';

const LeadLinkField = ({
  idSource = undefined,
  idValue = undefined,
  nameValue = undefined,
  nameSource = undefined,
  ...props
}: FieldProps) => {
  const { getValue: getIdValue } = useFieldHelper({ value: idValue, source: idSource });
  const { getValue: getNameValue } = useFieldHelper({ value: nameValue, source: nameSource });
  const { getSingleEntityUrl } = useLeadUrl();

  const url = getSingleEntityUrl(getIdValue());
  const name = getNameValue();

  return <TextField {...props} value={<Link to={url}>{name}</Link>} />;
};

export default LeadLinkField;
